module.exports = __webpack_public_path__ + "img/settings.b4dcf670.svg";